import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useId, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import './styles.css';


//export const getSpinnerColorDefault = () =>
const getSpinnerTitlePositionDefault = ()=>'bottom';
const getSpinnerSizeDefault = ()=>'medium';
const getSpinnerColorDefault = ()=>'black';

var styles = {
    "spinner": "Spinner-module_spinner__hvxb6",
    "spinner_black": "Spinner-module_spinner_black__r-Bxq",
    "spinner_blue": "Spinner-module_spinner_blue__EjA-I",
    "spinner_white": "Spinner-module_spinner_white__gvpj1",
    "spinner_small": "Spinner-module_spinner_small__hNLF-",
    "spinner_medium": "Spinner-module_spinner_medium__xalx8",
    "spinner_large": "Spinner-module_spinner_large__RmIft",
    "spinner_flexColumn": "Spinner-module_spinner_flexColumn__nk8v0",
    "spinner_flexRow": "Spinner-module_spinner_flexRow__Sucoi",
    "spinnerAnimation": "Spinner-module_spinnerAnimation__GMMoG",
    "spin": "Spinner-module_spin__WPMuU",
    "spinnerTitle": "Spinner-module_spinnerTitle__YYMNR",
    "spinnerTitle_centerText": "Spinner-module_spinnerTitle_centerText__DXz9Y",
    "srOnly": "Spinner-module_srOnly__0TC3m"
};

const Spinner = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, classNames, color = getSpinnerColorDefault(), titlePosition = getSpinnerTitlePositionDefault(), size = getSpinnerSizeDefault(), hideTitle, percentComplete, children }, ref)=>{
    const { t } = useTranslation('ds_progress', {
        i18n: dsI18n
    });
    const [isRendered, setIsRendered] = useState(false);
    const generatedId = useId();
    const titleId = `title-${id ?? generatedId}`;
    /**
     * useEffect sørger for at div med role=status blir rendret før children.
     * Dette gjør at skjermleser vet at den skal lytte etter tekster som må leses opp.
     */ useEffect(()=>{
        setTimeout(()=>{
            setIsRendered(true);
        }, 0);
    }, []);
    const sizeClassname = size ? styles[`spinner_${size}`] : undefined;
    const colorClassname = color ? styles[`spinner_${color}`] : undefined;
    const positionClassname = titlePosition === 'right' ? styles.spinner_flexRow : styles.spinner_flexColumn;
    const concatenatedClassnames = `${styles.spinner} ${colorClassname} ${positionClassname} ${sizeClassname} ${className} ${classNames?.container ?? ''}`.trim();
    const isInPercentageMode = percentComplete !== undefined;
    const spinnerLabel = t('spinner.LoadingLabel');
    const getAriaBusyStatus = ()=>{
        if (!isInPercentageMode) return undefined;
        if (percentComplete < 100) {
            return 'true';
        } else {
            return 'false';
        }
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs("div", {
                ref: ref,
                "aria-labelledby": isInPercentageMode ? titleId : undefined,
                "aria-live": !isInPercentageMode ? 'polite' : undefined,
                "aria-atomic": !isInPercentageMode ? 'true' : undefined,
                role: isInPercentageMode ? 'progressbar' : undefined,
                "aria-valuemin": isInPercentageMode ? 0 : undefined,
                "aria-valuemax": isInPercentageMode ? 100 : undefined,
                "aria-busy": getAriaBusyStatus(),
                "aria-valuenow": percentComplete,
                id: id,
                className: concatenatedClassnames,
                lang: lang,
                "data-testid": dataTestId,
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: `${styles.spinnerAnimation} ${classNames?.animation ?? ''}`.trim()
                    }),
                    /*#__PURE__*/ jsxs("span", {
                        id: titleId,
                        className: `${styles.spinnerTitle} ${hideTitle ? styles.srOnly : ''} ${titlePosition === 'bottom' ? styles.spinnerTitle_centerText : ''} ${classNames?.title ?? ''}`.trim(),
                        children: [
                            isInPercentageMode && `${spinnerLabel} (${percentComplete} %)`,
                            !isInPercentageMode && isRendered && (children ?? spinnerLabel)
                        ]
                    })
                ]
            }),
            isInPercentageMode && /*#__PURE__*/ jsx("div", {
                className: styles.srOnly,
                "aria-atomic": 'true',
                "aria-live": 'polite',
                children: `${percentComplete} %`
            })
        ]
    });
});
Spinner.displayName = 'Spinner';

export { Spinner, getSpinnerColorDefault, getSpinnerSizeDefault, getSpinnerTitlePositionDefault };
